var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.25H9C8.59 18.25 8.25 17.91 8.25 17.5C8.25 17.09 8.59 16.75 9 16.75H19C19.41 16.75 19.75 17.09 19.75 17.5C19.75 17.91 19.41 18.25 19 18.25Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.25H9C8.59 11.25 8.25 10.91 8.25 10.5C8.25 10.09 8.59 9.75 9 9.75H19C19.41 9.75 19.75 10.09 19.75 10.5C19.75 10.91 19.41 11.25 19 11.25Z",
    fill: "#4F5B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.25H9C8.59 4.25 8.25 3.91 8.25 3.5C8.25 3.09 8.59 2.75 9 2.75H19C19.41 2.75 19.75 3.09 19.75 3.5C19.75 3.91 19.41 4.25 19 4.25Z",
    fill: "#4F5B92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99994 5.24994C1.80994 5.24994 1.61994 5.17994 1.46994 5.02994L0.469941 4.02994C0.179941 3.73994 0.179941 3.25994 0.469941 2.96994C0.759941 2.67994 1.23994 2.67994 1.52994 2.96994L1.99994 3.43994L4.46994 0.969941C4.75994 0.679941 5.23994 0.679941 5.52994 0.969941C5.81994 1.25994 5.81994 1.73994 5.52994 2.02994L2.52994 5.02994C2.37994 5.17994 2.18994 5.24994 1.99994 5.24994Z",
    fill: "#4F5B92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99994 12.2499C1.80994 12.2499 1.61994 12.1799 1.46994 12.0299L0.469941 11.0299C0.179941 10.7399 0.179941 10.2599 0.469941 9.96994C0.759941 9.67994 1.23994 9.67994 1.52994 9.96994L1.99994 10.4399L4.46994 7.96994C4.75994 7.67994 5.23994 7.67994 5.52994 7.96994C5.81994 8.25994 5.81994 8.73994 5.52994 9.02994L2.52994 12.0299C2.37994 12.1799 2.18994 12.2499 1.99994 12.2499Z",
    fill: "#4F5B92"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99994 19.2499C1.80994 19.2499 1.61994 19.1799 1.46994 19.0299L0.469941 18.0299C0.179941 17.7399 0.179941 17.2599 0.469941 16.9699C0.759941 16.6799 1.23994 16.6799 1.52994 16.9699L1.99994 17.4399L4.46994 14.9699C4.75994 14.6799 5.23994 14.6799 5.52994 14.9699C5.81994 15.2599 5.81994 15.7399 5.52994 16.0299L2.52994 19.0299C2.37994 19.1799 2.18994 19.2499 1.99994 19.2499Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.ae991fddda83582fad26eb9877752527.svg";
export { ForwardRef as ReactComponent };